<template>
  <div class="focused-panel">
    <div class="d-flex workpack-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select Coverage" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit Coverage" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>


  </div>
</template>

<script>

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

  export default {
    name: 'workpack-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        geomType: 'Polygon',
        wellLayerName: 'v4:workpack',
        geometryName: 'coverage',
        wellAttrs: {

        }
      }
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/WorkpackEditor.vue